import apiUrl from '../../../../constants'
import user_tracker from '../../../../usertracker'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
//import {  Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import moment from 'moment'
import utils from '../../../../utils/validateScanner.js'
import IRTException from '../../../../utils/IRTException.js'
import { showMandatoryWeighingSnackbar, handleMandatoryWeighingHardBlock, isMandatoryWeighingSoftBlock, shouldShowMandatoryWeighingResultField } from '../../../../utils/mandatoryWeighingResponse.js'

import {
	BasicSelect
} from 'vue-search-select'

export default {
	name: 'manual',
	mixins: [utils,IRTException],
	components: {
		BasicSelect,
		Paginate,
		VueElementLoading
	},
	props: [],
	data() {
		return {
			VolumetricWeightPrint: '',
			PhysicalWeightPrint: '',
			pageCountrule: 0,
			pageCount: 0,
			pageNo: 0,
			isLoading: false,
			username: '',
			uasertype: '',
			hubid: '',
			hubname: '',
			WeightType: "NVW",
			ShipmentLength: '',
			ShipmentBreadth: '',
			ShipmentHeight: '',
			ShipmentID: '',
			ShipmentWeight: '',
			VolumetricWeight: '',
			isDisabled: true,
			isConfirmVolWt: true,
			isConfirmPhyWt: true,
			showIsConfirmVolWt: false,
			showIsConfirmPhyWt: false,
			showWeight: false,
			fullSuccessMessage: false,
			displayShipmentid: '',
			Destination: '',
			ProcessCode: '',
			ZoneName: '',
			showisConfirmPhyWtErr: '',
			showConfirmVolWtErr: '',
			audioregiontype: '',
			IsWeighingInfraAvailable: '',
			IsResultCodeBtn: false,
			timerenable: 1000,
			timerdisable: 1200,
			barcodecheck: 0,
			IsHeavyShipment:false,
			mpsType : '',
			inscanShipmentid:'',
			mandatoryWeighingSoftBlock: false,
			token: '',
			invalidTokenModal: false,
			invalidtokenmsg: '',
			timeoutHandler: 0,
			inputString:'',
			manualInput:false,
			userData:[],
			clientType : '',
			MPSQuantity:'',
			MpsGroupID:'',
			showQuentity:false,
			ServiceType: '',
			ParentHubs: '',
			section:null,
			bayNo:null,
			ptlid:null,
			priorityflag:null,
			MOT:'',
      		ShipmentType:'',
			shipmentModal:false,
			viewList:false,
			createBag:false,
			delinkShipment:false,
			confirmDelink:false,
			bagShipmentID:'',
			delinkBagShipmentID:'',
			bagSeal:'',
			basketData:{},
			bagDestinationObj:{},
			ShipmentList:[],
			ShipmentCount:0,
			bagShipmentIDError:'',
			bagSealError:'',
			delinkBagShipmentIDError:'',
			bShipInScan:false,
			bSealInScan:false,
			basketLoader:true,
			preModal:'',
			// FM Bagging
			handovertype:'',
			handovererrors:'',
			handoverBag:'',
			showfmlist:false,
			loadingFMList:false,
			fmPendencyList:[],
			handoverBagError: '',
			isfmbagInScan: false,
			fmbagInScanObj: {},
			fmMarkingIds: {},
			checked:[],
			supervisor: false,
			intiateFMShortage:false,
			pShipmentArr:[],
			showAdherenceModal:false,
			adherenceMsg:'',
			adherenceType:'',
			bagConfirmData:{}
		}
	},
	computed: {

	},
	filters: {
		moment: function(date) {
			if (date == null || date == '')
				return '--'
			return moment(date).format('DD-MM-YYYY HH:mm:ss');
		},
		toFixedNum: function(val) {
			if (val && val > 0) {
				return Number(parseFloat(val).toFixed(2));
			} else {
				return 0;
			}
			// var with2Decimals = val.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
			// return  with2Decimals
		},
	},
	mounted() {
		var userTokenEncrypt = window.localStorage.getItem('userToken')
		var userTokenDecrypt = CryptoJS.AES.decrypt(userTokenEncrypt.toString(), 'Key');
		var userToken = userTokenDecrypt.toString(CryptoJS.enc.Utf8);
		this.token = JSON.parse(userToken)
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.userData = userdetail;
		this.uasertype = userdetail[0].utype;
		this.username = userdetail[0].FirstName;
		this.hubid = userdetail[0].HubId;
		this.useremail = userdetail[0].email;
		this.userid = parseInt(userdetail[0].userid, 10); 
		this.$refs.ShipmentID.focus()
		this.getHubName(userdetail[0].HubId[0])
		// Get List of IRT Exception Type
		this.getExceptionTypes();
		// user_tracker.checkUserIP(userdetail[0], "manualinscan",this.$route.path);
	},
	methods: {
		displayMandatoryWeighingField(value) {
			return shouldShowMandatoryWeighingResultField(this.mandatoryWeighingSoftBlock, value);
		},
		applyMandatoryWeighingScanOutcome(data) {
			this.mandatoryWeighingSoftBlock = isMandatoryWeighingSoftBlock(data);
		},
		getDimensions() {
			this.$validator.reset();
			this.IsResultCodeBtn = false
			this.showIsConfirmVolWt = false;
			if (this.WeightType == "NVW") {
				this.ShipmentLength = '';
				this.ShipmentBreadth = '';
				this.ShipmentHeight = '';
				this.VolumetricWeight = '';
				this.ShipmentWeight = '';
				this.showIsConfirmVolWt = false;
				this.showIsConfirmPhyWt = false;
				this.isConfirmVolWt = false;
				this.isConfirmPhyWt = false;

				this.isDisabled = true;
				this.showWeight = false;
			} else if (this.WeightType == "CB") {
				this.isDisabled = false;
				this.showWeight = true;
			} else if (this.WeightType == "CP") {
				this.isDisabled = false;
				this.showWeight = true;
			} else if (this.WeightType == "PB") {
				this.ShipmentLength = '';
				this.ShipmentBreadth = '';
				this.ShipmentHeight = '';
				this.VolumetricWeight = '';
				this.ShipmentWeight = '';
				this.VolumetricWeight = '';
				this.showIsConfirmVolWt = false;
				this.showIsConfirmPhyWt = false;
				this.isConfirmVolWt = false;
				this.isConfirmPhyWt = false;

				this.isDisabled = true;
				this.showWeight = false;
			}
		},
		showCondition() {
			this.VolumetricWeight = (this.ShipmentLength * this.ShipmentBreadth * this.ShipmentHeight) / 6000;
			if (this.VolumetricWeight >= 20) {
				this.showIsConfirmVolWt = true;
			} else {
				this.showIsConfirmVolWt = false;
			}

			// if (this.VolumetricWeight >= 170) {
			//   this.$alertify.error('LBH Dimensions Cannot be greater than 170');
			//   return false
			// }
		},
		checkIsShipmentWeight() {
			if (this.ShipmentWeight >= 20) {
				this.showIsConfirmPhyWt = true;
			} else {
				this.showIsConfirmPhyWt = false;
			}
		},
		uncheck() {
			if (this.isConfirmVolWt == true) {
				this.showConfirmVolWtErr = '';
			} else {
				this.showConfirmVolWtErr = 'Please Select Confirm Volumetric Weight';
			}
			if (this.isConfirmPhyWt == true) {
				this.showisConfirmPhyWtErr = '';
			} else {
				this.showisConfirmPhyWtErr = 'Please Select Confirm Physical Weight';
			}
		},
		getHubName(hubid) {
			this.input = {
				hubids: [hubid]
			}
			axios({
					method: 'POST',
					url: apiUrl.api_url_hubops + 'expose/hubservicecenter/hubarray/get',
					data: this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(async result => {
					if (result.data.ResultCode == 100) {
						this.IsWeighingInfraAvailable = result.data.ResponseData[0].IsWeighingInfraAvailable
						this.hubname = result.data.ResponseData[0].HubName

						await this.hubForManualRestriction(this.hubname,this.IsWeighingInfraAvailable);
					}
				}, error => {
					console.error(error);
				})
		},
		logout(e) {
			localStorage.removeItem('permissiondata')
			localStorage.removeItem('userdetail')
			localStorage.removeItem('userToken')
			localStorage.removeItem('isLoggedIn')
			localStorage.removeItem('loginDate')
			this.$router.push('/login')
			e.preventDefault()
		},
		closeinvalidTokenModal() {
			this.invalidTokenModal = false
			this.invalidtokenmsg = ''
		},
		Inscan(pickupExists) {
			if (this.WeightType == 'NVW') {
				this.isConfirmPhyWt = false;
				this.isConfirmVolWt = false;
			}
			if (this.VolumetricWeight >= 20 && this.isConfirmVolWt == false && this.ShipmentWeight >= 20 && this.isConfirmPhyWt == false) {
				this.showConfirmVolWtErr = 'Please Select Confirm Volumetric Weight';
				this.showisConfirmPhyWtErr = 'Please Select Confirm Physical Weight';
			} else if (this.VolumetricWeight >= 20 && this.isConfirmVolWt == false) {
				this.showConfirmVolWtErr = 'Please Select Confirm Volumetric Weight';
			} else if (this.ShipmentWeight >= 20 && this.isConfirmPhyWt == false) {
				this.showisConfirmPhyWtErr = 'Please Select Confirm Physical Weight';
			}
			// else if (this.VolumetricWeight >= 170) {
			//   this.$alertify.error('LBH Dimensions Cannot be greater than 170');
			//   return false;
			// }
			else {
				var date = new Date();
				this.isLoading = true;
				this.input = ({
					"shippingID": this.ShipmentID.toString(),
					"originHubID": this.hubid[0],
					"lastModifiedBy": this.useremail,
					"isConfirmInScan": true,
					"isConfirmVolWt": this.isConfirmVolWt,
					"isConfirmPhyWt": this.isConfirmPhyWt,
					"inScanFromDevice": this.WeightType,
					"latitude": null,
					"longitude": null,
					"deviceID": null,
					"deviceCapturedDate": moment(date).format('YYYY-MM-DD'),
					"statusMarkedFrom": "WEB",
					"inscanType": 1,
					"isWeighingInfraAvailable": this.IsWeighingInfraAvailable,
					"isManualEntry": this.manualInput
				})
				if (this.userid) {
					this.input.userId = this.userid;
				  }
				if (this.WeightType == "NVW") {
					this.input.shipmentLength = 0;
					this.input.shipmentBreadth = 0;
					this.input.shipmentHeight = 0;
					this.input.physicalWeight = 0;
				} else if (this.WeightType == "CB") {
					this.input.shipmentLength = Number(this.ShipmentLength);
					this.input.shipmentBreadth = Number(this.ShipmentBreadth);
					this.input.shipmentHeight = Number(this.ShipmentHeight);
					this.input.physicalWeight = Number(this.ShipmentWeight);
				} else if (this.WeightType == "CP") {
					this.input.shipmentLength = Number(this.ShipmentLength);
					this.input.shipmentBreadth = Number(this.ShipmentBreadth);
					this.input.shipmentHeight = Number(this.ShipmentHeight);
					this.input.physicalWeight = Number(this.ShipmentWeight);
				} else if (this.WeightType == "PB") {
					this.input.shipmentLength = 0;
					this.input.shipmentBreadth = 0;
					this.input.shipmentHeight = 0;
					this.input.physicalWeight = 0;
				}

				if (pickupExists) {
					this.input.isPickUpBasketFacility = true;
				}

				// FM Bagging
				if(this.restrictionConfig && this.restrictionConfig.isFmBaggingLoc && this.handoverBag) {
					this.input.bagNumber = this.handoverBag;
				}

				if (this.isAdherenceFalse) {
					this.input.isAdherence = false;
					this.isAdherenceFalse = false;
				}

				axios({
						method: 'POST',
						url: apiUrl.api_url_hubops + 'manualShipmentInScan',
						data: this.input,
						headers: {
							'authorization': 'authkey xB84JJ89Hd25',
							'requestfrom': "WEB",
							'token': this.token
						}
					})
					.then(result => {
						if (handleMandatoryWeighingHardBlock(this, result.data, 'manualShipmentInScan')) {
							this.isLoading = false;
							this.$validator.reset();
							this.$refs.ShipmentID.focus();
							return;
						}
						if (result.data.ResultCode == 100) {
							showMandatoryWeighingSnackbar(this, result.data);
							this.applyMandatoryWeighingScanOutcome(result.data);
							this.invalidTokenModal = false
							this.inscanShipmentid = this.ShipmentID
							this.isLoading = false;
							this.ShipmentID = '';
							this.manualInput = false
							this.clientType='';
							// setTimeout(function() {
							// 	document.getElementById("ShipmentID").disabled = false;
							// 	this.barcodecheck = 0;
							// }, this.timerdisable);
							if (this.WeightType == "CB") {
								// this.ShipmentLength = '';
								// this.ShipmentBreadth = '';
								// this.ShipmentHeight = '';
								// this.ShipmentWeight = '';
								// this.VolumetricWeight = '';
								// this.isConfirmVolWt = false;
								// this.isConfirmPhyWt = false;
								// this.showIsConfirmVolWt = false;
								// this.showIsConfirmPhyWt = false;
								if (this.VolumetricWeight >= 20) {
									this.showIsConfirmVolWt = true;
								} else {
									this.showIsConfirmVolWt = false;
									this.isConfirmVolWt = false;
								}
								if (this.ShipmentWeight >= 20) {
									this.showIsConfirmPhyWt = true;
								} else {
									this.showIsConfirmPhyWt = false;
									this.isConfirmPhyWt = false;
								}

							} else if (this.WeightType == "CP") {
								// this.ShipmentLength = '';
								// this.ShipmentBreadth = '';
								// this.ShipmentHeight = '';
								// this.VolumetricWeight = '';
								// this.ShipmentWeight = '';
								// this.isConfirmVolWt = false;
								// this.isConfirmPhyWt = false;
								// this.showIsConfirmVolWt = false;
								// this.showIsConfirmPhyWt = false;

								if (this.VolumetricWeight >= 20) {
									this.showIsConfirmVolWt = true;
								} else {
									this.showIsConfirmVolWt = false;
									this.isConfirmVolWt = false;
								}
								if (this.ShipmentWeight >= 20) {
									this.showIsConfirmPhyWt = true;
								} else {
									this.showIsConfirmPhyWt = false;
									this.isConfirmPhyWt = false;
								}
							}
							this.$alertify.success(result.data.ReturnMessage);
							this.showHubColorCode();
							this.fmBagSealInScan();
							this.$validator.reset()
						} else if (result.data.ResultCode == 109) {
							this.invalidTokenModal = false
							this.isLoading = false;
							this.showIsConfirmVolWt = true;
							this.$alertify.error(result.data.ReturnMessage);
							this.IsResultCodeBtn = true
							//this.manualInscan(pickupExists)
						} else if (result.data.ResultCode == 401) {
							this.isLoading = false;
							this.invalidTokenModal = true
							this.invalidtokenmsg = result.data.ReturnMessage
							this.$alertify.error(result.data.ReturnMessage)
					    } else if (result.data.ResultCode == 208) {
					    		this.isLoading = false;
					    		this.adherenceMsg = result.data.ReturnMessage;
					    		this.adherenceType = 'inscan';
					    		this.showAdherenceModal = true;
					    	}else {
							// IRT Exception Error & Tracking No
							if(result.data.Trackingno) this.openIRTExceptionModal(this.ShipmentID, result.data.ReturnMessage, result.data.Trackingno);
							this.manualInput = false
							this.invalidTokenModal = false
							this.ShipmentID = '';
							this.inscanShipmentid = '';
							// this.barcodecheck = 0;
							// setTimeout(function() {
							// 	document.getElementById("ShipmentID").disabled = false;
							// }, this.timerdisable);
							// this.ShipmentLength = '';
							// this.ShipmentBreadth = '';
							// this.ShipmentHeight = '';
							// this.VolumetricWeight = '';
							// this.ShipmentWeight = '';
							// this.isDisabled = true;
							// this.isConfirmVolWt = false;
							// this.isConfirmPhyWt = false;
							// this.showIsConfirmVolWt = false;
							// this.showIsConfirmPhyWt = false;
							// this.showWeight = false;
							this.IsResultCodeBtn = false
							this.fullSuccessMessage = false;
							this.isLoading = false
							this.schedulesList = [];
							this.$alertify.error(result.data.ReturnMessage);
							this.$validator.reset()
						}
						// this.barcodecheck = 0;
						// setTimeout(function() {
						// 	document.getElementById("ShipmentID").disabled = false;
						// }, this.timerdisable);
						this.$refs.ShipmentID.focus()
						user_tracker.checkUserIP(this.userData[0], "manualinscan",this.$route.path,this.input);
					}, error => {
						this.isLoading = false
						console.error(error)
					})
			}

		},

		confirmAdherence() {
			this.showAdherenceModal = false;
			if (this.adherenceType === 'bag') {
				this.isfmbagInScan = true;
				this.fmbagInScanObj = this.bagConfirmData;
				this.handoverBag = this.fmbagInScanObj.bagSealNumber ;
				return;
			}
			this.isAdherenceFalse = true;
			this.Inscan(this.restrictionConfig && this.restrictionConfig.pickupExists ? this.restrictionConfig.pickupExists : null);
		},

		cancelAdherence() {
			this.showAdherenceModal = false;
			if (this.adherenceType === 'bag') {
				this.bagConfirmData = {};
			}
		},

		manualInscan(pickupExists) {
			
			if (this.ShipmentID != '') {
				if (this.ShipmentID.length < 7) {
					document.getElementById("ShipmentID").value = "";
					this.shipmentno = "";
					// this.barcodecheck = 0;
					// setTimeout(function() {
					// 	document.getElementById("ShipmentID").disabled = false;
					// }, this.timerdisable);
					this.$alertify.error("Invalid Barcode(Use Scanner Only)");
					return false;
				} else {
					this.$alertify.success("Valid Barcode");
				}
			} else {
				this.$alertify.error("Please Enter ShipmentId");
				return false;
			}
			if (this.isConfirmVolWt == false) {
				this.showConfirmVolWtErr = 'Please Select Confirm Volumetric Weight';
				return false;
			} else {
				this.showConfirmVolWtErr = ''
			}
			if (this.VolumetricWeight >= 20 && this.isConfirmVolWt == false && this.ShipmentWeight >= 20 && this.isConfirmPhyWt == false) {
				this.showConfirmVolWtErr = 'Please Select Confirm Volumetric Weight';
				this.showisConfirmPhyWtErr = 'Please Select Confirm Physical Weight';
			} else if (this.VolumetricWeight >= 20 && this.isConfirmVolWt == false) {
				this.showConfirmVolWtErr = 'Please Select Confirm Volumetric Weight';
			} else if (this.ShipmentWeight >= 20 && this.isConfirmPhyWt == false) {
				this.showisConfirmPhyWtErr = 'Please Select Confirm Physical Weight';
			}
			// else if (this.VolumetricWeight >= 170) {
			//   this.$alertify.error('LBH Dimensions Cannot be greater than 170');
			//   return false;
			// }
			else {
				var date = new Date();
				this.isLoading = true;
				this.input = ({
					"shippingID": this.ShipmentID.toString(),
					"originHubID": this.hubid[0],
					"lastModifiedBy": this.useremail,
					"isConfirmInScan": true,
					"isConfirmVolWt": this.isConfirmVolWt,
					"isConfirmPhyWt": this.isConfirmPhyWt,
					"inScanFromDevice": this.WeightType,
					"latitude": null,
					"longitude": null,
					"deviceID": null,
					"deviceCapturedDate": moment(date).format('YYYY-MM-DD'),
					"statusMarkedFrom": "WEB",
					"inscanType": 1,
					"isWeighingInfraAvailable": this.IsWeighingInfraAvailable,
					"isManualEntry": this.manualInput
				})
				if (this.WeightType == "NVW") {
					this.input.shipmentLength = 0;
					this.input.shipmentBreadth = 0;
					this.input.shipmentHeight = 0;
					this.input.physicalWeight = 0;
				} else if (this.WeightType == "CB") {
					this.input.shipmentLength = Number(this.ShipmentLength);
					this.input.shipmentBreadth = Number(this.ShipmentBreadth);
					this.input.shipmentHeight = Number(this.ShipmentHeight);
					this.input.physicalWeight = Number(this.ShipmentWeight);
				} else if (this.WeightType == "CP") {
					this.input.shipmentLength = Number(this.ShipmentLength);
					this.input.shipmentBreadth = Number(this.ShipmentBreadth);
					this.input.shipmentHeight = Number(this.ShipmentHeight);
					this.input.physicalWeight = Number(this.ShipmentWeight);
				} else if (this.WeightType == "PB") {
					this.input.shipmentLength = 0;
					this.input.shipmentBreadth = 0;
					this.input.shipmentHeight = 0;
					this.input.physicalWeight = 0;
				}

				if (pickupExists) {
					this.input.isPickUpBasketFacility = true;
					this.input.userId = this.userid;
				}

				// FM Bagging
				if(this.restrictionConfig && this.restrictionConfig.isFmBaggingLoc && this.handoverBag) {
					this.input.bagNumber = this.handoverBag;
				}

				axios({
						method: 'POST',
						url: apiUrl.api_url_hubops + 'manualShipmentInScan',
						data: this.input,
						headers: {
							'authorization': 'authkey xB84JJ89Hd25',
							'requestfrom': "WEB",
							'token': this.token
						}
					})
					.then(result => {
						if (handleMandatoryWeighingHardBlock(this, result.data, 'manualShipmentInScan')) {
							this.isLoading = false;
							this.$validator.reset();
							this.$refs.ShipmentID.focus();
							return;
						}
						if (result.data.ResultCode == 100) {
							showMandatoryWeighingSnackbar(this, result.data);
							this.applyMandatoryWeighingScanOutcome(result.data);
							this.invalidTokenModal = false
							this.inscanShipmentid = this.ShipmentID
							this.isLoading = false;
							this.ShipmentID = '';
							this.manualInput = false
							this.clientType = '';
							// this.barcodecheck = 0;
							// setTimeout(function() {
							// 	document.getElementById("ShipmentID").disabled = false;
							// }, this.timerdisable);
							if (this.WeightType == "CB") {
								// this.ShipmentLength = '';
								// this.ShipmentBreadth = '';
								// this.ShipmentHeight = '';
								// this.ShipmentWeight = '';
								// this.VolumetricWeight = '';
								// this.isConfirmVolWt = false;
								// this.isConfirmPhyWt = false;
								// this.showIsConfirmVolWt = false;
								// this.showIsConfirmPhyWt = false;
								if (this.VolumetricWeight >= 20) {
									this.showIsConfirmVolWt = true;
								} else {
									this.showIsConfirmVolWt = false;
									this.isConfirmVolWt = false;
								}
								if (this.ShipmentWeight >= 20) {
									this.showIsConfirmPhyWt = true;
								} else {
									this.showIsConfirmPhyWt = false;
									this.isConfirmPhyWt = false;
								}
							} else if (this.WeightType == "CP") {
								// this.ShipmentLength = '';
								// this.ShipmentBreadth = '';
								// this.ShipmentHeight = '';
								// this.VolumetricWeight = '';
								// this.ShipmentWeight = '';
								// this.isConfirmVolWt = false;
								// this.isConfirmPhyWt = false;
								// this.showIsConfirmVolWt = false;
								// this.showIsConfirmPhyWt = false;
								if (this.VolumetricWeight >= 20) {
									this.showIsConfirmVolWt = true;
								} else {
									this.showIsConfirmVolWt = false;
									this.isConfirmVolWt = false;
								}
								if (this.ShipmentWeight >= 20) {
									this.showIsConfirmPhyWt = true;
								} else {
									this.showIsConfirmPhyWt = false;
									this.isConfirmPhyWt = false;
								}
							}

							this.IsResultCodeBtn = false
							this.showIsConfirmVolWt = false;
							this.$alertify.success(result.data.ReturnMessage);
							this.showHubColorCode();
							this.$validator.reset()
						} else if (result.data.ResultCode == 401) {
							this.isLoading = false;
							this.invalidTokenModal = true
							this.invalidtokenmsg = result.data.ReturnMessage
							this.$alertify.error(result.data.ReturnMessage)
						} else {

							// IRT Exception Error & Tracking No
							if(result.data.Trackingno) this.openIRTExceptionModal(this.ShipmentID, result.data.ReturnMessage, result.data.Trackingno);

							this.manualInput = false
							this.invalidTokenModal = false
							this.inscanShipmentid = '';
							//this.ShipmentID = '';
							// this.ShipmentLength = '';
							// this.ShipmentBreadth = '';
							// this.ShipmentHeight = '';
							// this.VolumetricWeight = '';
							// this.ShipmentWeight = '';
							//
							// this.isDisabled = true;
							// this.isConfirmVolWt = false;
							// this.isConfirmPhyWt = false;
							// this.showIsConfirmVolWt = false;
							// this.showIsConfirmPhyWt = false;
							// this.showWeight = false;
							this.fullSuccessMessage = false;
							this.isLoading = false
							this.schedulesList = [];
							this.IsResultCodeBtn = false
							this.showIsConfirmVolWt = false;
							this.$alertify.error(result.data.ReturnMessage);
							this.$validator.reset()
						}

						// if(result.data.ResultCode != 100 && result.data.ResultCode != 109){
						//   this.$alertify.error(result.data.ReturnMessage);
						//   this.IsResultCodeBtn = false
						//   this.isLoading = false;
						//   this.showIsConfirmVolWt = false;
						// }
						// this.barcodecheck = 0;
						// setTimeout(function() {
						// 	document.getElementById("ShipmentID").disabled = false;
						// }, this.timerdisable);
						this.$refs.ShipmentID.focus()
						user_tracker.checkUserIP(this.userData[0], "manualinscan",this.$route.path,this.input);
					}, error => {
						this.isLoading = false
						console.error(error)
					})
			}
		},

		showHubColorCode(ShipmentID) {
			this.MPSQuantity='';
			this.MpsGroupID='';
			this.showQuentity=false;
			this.MOT = '';
      		this.ShipmentType = '';
			
			let pupStr = (this.restrictionConfig && this.restrictionConfig.pickupExists) ? `&isPickUpBasketFacility=true&userId=${this.userid}` : '';

			axios({
					method: 'GET',
					'url': apiUrl.api_url_hubops + "getHubColourCode?shippingID=" + this.inscanShipmentid + pupStr,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
						'requestfrom': "WEB",
						'token': this.token
					}
				})
				.then(result => {
					if (result.data.ResultCode == 100) {
						// PXB-7142 Shipment Color Code & Icon
						if(result.data.lossCategorization && Object.keys(result.data.lossCategorization).length !=0){
							this.showHideCodeIconInput(result.data.lossCategorization.colorCode, result.data.lossCategorization.icon);
						}
						
						// Multiple processing Center Connectivity
						this.pickUpBasketData = (this.pickUpBasketData) ? result.data.ResponseData.pickUpBasketData :[];

						this.invalidTokenModal = false
						this.isLoading = false;
						this.fullSuccessMessage = true;
						this.IsHeavyShipment = result.data.isHeavyShipment
						this.mpsType = result.data.ResponseData.mpsType
						this.Destination = (this.pickUpBasketData) ? result.data.ResponseData.nextBagDestination : result.data.ResponseData.HubName;
						this.ProcessCode = result.data.ResponseData.ProcessCode;
						this.ZoneName = result.data.ResponseData.ZoneName;
						this.displayShipmentid = result.data.ResponseData.shippingId || this.displayShipmentid;
						this.VolumetricWeightPrint = result.data.ResponseData.volumetricweight;
						this.PhysicalWeightPrint = result.data.ResponseData.physicalWeight;
						this.clientType = result.data.ResponseData.clientType;
						this.ServiceType = result.data.ResponseData.serviceType;
						this.ParentHubs = result.data.ResponseData.parenthubs;
						this.section = result.data.ResponseData.sortersection;
						this.bayNo = result.data.ResponseData.bayno;
						this.priorityflag = result.data.ResponseData.fmPriorityFlag;
						this.MOT = result.data.ResponseData.MOT;
            			this.ShipmentType = result.data.ResponseData.ShipmentType;
						this.ptlid = (this.section && this.section.includes('PTL') && result.data.ResponseData.ptlid) ? result.data.ResponseData.ptlid : ``;
						if(result.data.ResponseData.count){
							this.MPSQuantity = result.data.ResponseData.count;
							this.MpsGroupID = result.data.ResponseData.mpsGroupId;
							this.showQuentity =true
						}
						if (this.displayMandatoryWeighingField(this.ZoneName)) {
							this.playAudio(this.ZoneName);
						}
						// this.$alertify.success(result.data.ReturnMessage)
					} else if (result.data.ResultCode == 401) {
						this.isLoading = false;
						this.invalidTokenModal = true
						this.IsHeavyShipment = false
						this.mpsType = ''
						this.invalidtokenmsg = result.data.ReturnMessage
						this.$alertify.error(result.data.ReturnMessage)
					} else {
						this.manualInput = false
						this.invalidTokenModal = false
						this.isLoading = false;
						this.fullSuccessMessage = false;
						this.IsHeavyShipment = false
						this.mpsType = ''
						this.displayShipmentid = '';
						this.inscanShipmentid = '';
						this.Destination = '';
						this.ProcessCode = '';
						this.ZoneName = '';
						this.$alertify.error(result.data.ReturnMessage);
					}
				}, error => {
					this.isLoading = false;
					this.$alertify.error("Failed to show hub color code")
					console.error(error)
				})
		},
		playAudio(ZoneName) {
			ZoneName = ZoneName.toLowerCase()
			switch (ZoneName) {
				case "north":
					var sound = "https://audioposts-13082019.s3.ap-south-1.amazonaws.com/0652d446-4b28-4e0a-85bd-e65ad2ce9ec2.mp3"
					var audio = new Audio(sound);
					audio.play();
					break;
				case "south":
					var sound = "https://audioposts-13082019.s3.ap-south-1.amazonaws.com/31723278-6ae0-4836-8cc9-b2669a201048.mp3"
					var audio = new Audio(sound);
					audio.play();
					break;
				case "east":
					var sound = "https://audioposts-13082019.s3.ap-south-1.amazonaws.com/18cf489b-7feb-4f6d-82c4-9d1ab1568a7a.mp3"
					var audio = new Audio(sound);
					audio.play();
					break;
				case "west":
					var sound = "https://audioposts-13082019.s3.ap-south-1.amazonaws.com/e1a173bb-b880-4293-b721-3043320bf6fd.mp3"
					var audio = new Audio(sound);
					audio.play();
					break;
				case "central":
					var sound = "https://audioposts-13082019.s3.ap-south-1.amazonaws.com/928d2177-d8d5-4366-9027-2665ebfed449.mp3"
					var audio = new Audio(sound);
					audio.play();
					break;
				case "north east":
					var sound = "https://audioposts-13082019.s3.ap-south-1.amazonaws.com/a16717ca-bd5a-46e2-949e-05425dc6ff81.mp3"
					var audio = new Audio(sound);
					audio.play();
					break;
				case "south-1":
					var sound = "https://audioposts-13082019.s3.ap-south-1.amazonaws.com/293e8714-2f74-441f-9ef6-88d2b0450cd6.mp3"
					var audio = new Audio(sound);
					audio.play();
					break;
				case "south-2":
					var sound = "https://audioposts-13082019.s3.ap-south-1.amazonaws.com/e27c8c00-9fc3-420b-9bc8-04d3dd727224.mp3"
					var audio = new Audio(sound);
					audio.play();
					break;
				default:
					console.log("No zone found to play audio");
			}
		},

		onSubmit: function(pickupExists) {
			// if (this.ShipmentID != '') {
			// 	if (this.ShipmentID.length < 7) {
			// 		document.getElementById("ShipmentID").value = "";
			// 		this.shipmentno = "";
			// 		document.getElementById("ShipmentID").disabled = false;
			// 		this.barcodecheck = 0;
			// 		this.$alertify.error("Invalid Barcode(Use Scanner Only)");
			// 		return false;
			// 	} else {
			// 		this.$alertify.success("Valid Barcode");
			// 	}
			// } else {
			// 	this.$alertify.error("Please Enter ShipmentId");
			// 	return false;
			// }
			var self = this
			this.$validator.validateAll().then((result) => {

				if (result) {
					this.pageNo = 0
					// @click="Inscan"
					this.Inscan(pickupExists)
				} else {
					console.log('errors exist', this.errors)
				}
			}).catch(() => {
				console.log('errors exist')
			});
		},
		resetForm() {
			this.$refs.ShipmentID.focus()
			// document.getElementById("ShipmentID").disabled = false;
			// this.barcodecheck = 0;
			this.handovererrors = '';
			this.ShipmentID = '';
			this.WeightType = "NVW"
			this.ShipmentLength = '';
			this.ShipmentBreadth = '';
			this.ShipmentHeight = '';
			this.VolumetricWeight = '';
			this.ShipmentWeight = '';
			this.isDisabled = true;
			this.isConfirmVolWt = false;
			this.isConfirmPhyWt = false;
			this.showIsConfirmVolWt = false;
			this.showIsConfirmPhyWt = false;
			this.showWeight = false;
			this.fullSuccessMessage = false;
			this.IsResultCodeBtn = false
			this.IsHeavyShipment = false
			this.mpsType = ''
			this.displayShipmentid = '';
			this.inscanShipmentid = '';
			this.Destination = '';
			this.ProcessCode = '';
			this.ZoneName = '';
			this.manualInput = false;
			this.ServiceType = '';
			this.ParentHubs = '';
			this.MPSQuantity='';
			this.MpsGroupID='';
			this.showQuentity=false;
			// FM Bagging
			this.handovertype = '';
			this.handovererrors = '';
			this.handoverBag = '';
			this.showfmlist = false;
			this.loadingFMList= false;
			this.fmPendencyList= [];
			this.bagSealError= '',
			this.isfmbagInScan= false;
			this.fmbagInScanObj= {};
			this.$validator.reset();

			this.showHideCodeIconInput();
		},

		fetchBagShipmentList(data,type,i) {

			this.closeCreateDelinkModal();

			this.basketData = data ? data : this.basketData;
			this.basketData = Object.assign({}, this.basketData, {i:i});

			this.shipmentModal = true;
			this.basketLoader = true;
			
			if(type=='list') {	

				axios({
					method: 'GET',
					'url': apiUrl.api_url_hubops + 'pickupCenter/getShipmentCountList?pickupHubId=' + this.hubid + '&basketBarcode=' + this.basketData.basket+'&requestType=2',
					'data': {},
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					if (result.data.ResultCode == 100) {

						this.ShipmentList = result.data.ShipmentList;
						this.ShipmentCount = result.data.ShipmentCount;

						this.viewList = true;
					}else{
						this.shipmentModal = false;
						this.$alertify.error(result.data.ReturnMessage);
						return false;
					}
				}, error => {
					this.shipmentModal = false;
					console.error(error);
				})
			}
			else if(type=='delink') this.delinkShipment = true;
			else if(type=='bag') this.createBag = true;

			this.basketLoader = false;
		},

		delinkBagShipment(i) {

			if (!this.delinkBagShipmentID) {
				this.delinkBagShipmentIDError = 'The Shipping ID field is required.'; return;
			}
			this.delinkBagShipmentIDError = '';
			this.basketLoader = true;

			this.input = ({
				"shippingId": this.delinkBagShipmentID.toString(),
				"pickupHubId": this.hubid[0],
				"basketBarcode": this.basketData.basket,
				"modifiedBy": this.useremail
			})
			axios({
				method: 'POST',
				url: apiUrl.api_url_hubops + 'pickupCenter/delinkShipment',
				data: this.input,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			})
			.then(result => {
				if (result.data.ResultCode == 100) {

					this.delinkBagShipmentID = '';

					this.basketData = Object.assign({}, this.basketData, {count:result.data.RemainingLinkedCount});
					this.pickUpBasketData[i].count = result.data.RemainingLinkedCount;

					this.$alertify.success(result.data.ReturnMessage);
				}else{
					this.$alertify.error(result.data.ReturnMessage);
				}
				this.basketLoader = false;
			}, error => {
				this.basketLoader = false;
				console.error(error);
			})
		},

		takeAction(i) {
			if(this.preModal=='delink') {
				// Delink All shipment
				this.delinkAllBagShipment(i);
			} else {
				// Close Bag Modal
				this.closeCreateDelinkModal();
			}
		},

		delinkAllBagShipment(i) {
			this.basketLoader = true;

			this.input = ({
				"pickupHubId": this.hubid[0],
				"basketBarcode": this.basketData.basket,
				"modifiedBy": this.useremail
			})
			axios({
				method: 'POST',
				url: apiUrl.api_url_hubops + 'pickupCenter/delinkAllShipments',
				data: this.input,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			})
			.then(result => {
				if (result.data.ResultCode == 100) {

					this.basketData = Object.assign({}, this.basketData, {count:0});
					this.pickUpBasketData[i].count = 0;

					this.$alertify.success(result.data.ReturnMessage);
				}else{
					this.$alertify.error(result.data.ReturnMessage);
				}
				this.basketLoader = false;
			}, error => {

				this.basketLoader = false;
				console.error(error);
			})
		},

		scanBagShipment() {
			if (!this.bagShipmentID) {
				this.bagShipmentIDError = 'The Shipping ID field is required.'; return;
			}
			this.bagShipmentIDError = '';

			this.bShipInScan = false;
			this.basketLoader = false;

			axios({
				method: 'GET',
				'url': apiUrl.api_url_hubops + 'pickupCenter/scanShipmentForBagClose?pickupHubId=' + this.hubid + '&basketBarcode=' + 
				this.basketData.basket+'&shippingId=' + this.bagShipmentID.toString()+'&createdBy=' + this.useremail,
				'data': {},
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			})
			.then(result => {
				if (result.data.ResultCode == 100) {

					this.bShipInScan = true;
					this.bagShipmentID = '';
					this.$alertify.success(result.data.ReturnMessage);
				}else{
					this.$alertify.error(result.data.ReturnMessage);
				}
				this.basketLoader = false;
			}, error => {

				this.basketLoader = false;
				console.error(error);
			})
		},

		scanBagSeal() {
			if (!this.bagSeal) {
				this.bagSealError = 'Seal Number field is required.'; return;
			}
			this.bagSealError = '';

			this.bSealInScan = false;
			this.basketLoader = true;
			this.bagDestinationObj={};

			axios({
				method: 'GET',
				'url': apiUrl.api_url_hubops + 'pickupCenter/scanBagSealApi?pickupHubId='+this.hubid+'&basketBarcode='+ 
				this.basketData.basket+'&bagDestinationHubName='+this.basketData.nextbagdestination+'&bagSealNo='+this.bagSeal+'&bagType=surfacebag'+
				'&createdBy=' + this.useremail+'&userId=' + this.userid,
				'data': {},
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			})
			.then(result => {
				if (result.data.ResultCode == 100) {

					this.bSealInScan = true;
					
					this.bagDestinationObj = {
						"bagDestinationHubId": result.data.ResponseData.destinationHubId,
						"bagDestinationHubName": result.data.ResponseData.destinationHubName,
						"groupId": result.data.ResponseData.groupId
					}

					this.$alertify.success(result.data.ReturnMessage);
				}else{
					this.$alertify.error(result.data.ReturnMessage);
				}
				this.basketLoader = false;
			}, error => {
				this.basketLoader = false;
				console.error(error);
			})
		},

		closeBag() {
			this.basketLoader = true;
			
			this.input = ({
				"pickupHubId": Number(this.hubid[0]),
				"pickupHubName": this.hubname,
				"basketBarcode": this.basketData.basket,
				"bagSealNo": this.bagSeal,
				"bagDestinationHubId": this.bagDestinationObj.bagDestinationHubId,
				"bagDestinationHubName": this.bagDestinationObj.bagDestinationHubName,
				"groupId": this.bagDestinationObj.groupId,
				"bagType": 'surfacebag',
				"createdBy": this.useremail,
				"userId": this.userid
			})
			axios({
				method: 'POST',
				url: apiUrl.api_url_hubops + 'pickupCenter/bagCloseApi',
				data: this.input,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			})
			.then(result => {
				if (result.data.ResultCode == 100) {

					this.pickUpBasketData[this.basketData.i].count = 0;

					this.basketData = {};
					this.closeCreateDelinkModal();
					
					this.$alertify.success(result.data.ReturnMessage);
				}else{
					this.$alertify.error(result.data.ReturnMessage);
				}
				this.basketLoader = false;
			}, error => {

				this.basketLoader = false;
				console.error(error);
			})
		},

		closeCreateDelinkModal() {
			this.shipmentModal = false;
			this.viewList = false;
			this.createBag = false;
			this.delinkShipment = false;
			this.confirmDelink = false;

			this.resetBasketModule();

			this.ShipmentList = [];
			this.ShipmentCount = 0;
		},

		resetBasketModule() {
			this.bagShipmentID = '';
			this.bagShipmentIDError = '';
			this.bagSeal = '';
			this.bagSealError = '';
			this.delinkBagShipmentID = '';
			this.delinkBagShipmentIDError = '';
			this.bagDestinationObj={};
			this.bShipInScan = false;
			this.bSealInScan = false;
			this.basketLoader = false;
		},

		// FM Bagging
		fmBagSealInScan() {
			if (this.handovertype == '') {
				this.handovererrors = 'The Scan Type field is required.'; return;
			} else if (!this.handoverBag) {
				this.handoverBagError = 'Bag Number field is required.'; return;
			}

			// Match role for SUpervisor
			this.supervisor = this.validateUserRole(this.roleconfig.sup_roles_fmb_shortage);
            // this.supervisor =false;

			this.handovererrors = '';
			this.handoverBagError = '';
			this.isfmbagInScan = false;

			this.isLoading = true;
			this.fmbagInScanObj={};

			this.input = ({
				"hubId": this.hubid[0],
				"bagSealNumber": this.handoverBag,
				"eventName": "FmBagValidate",
				"userId": this.userid
			})
			axios({
				method: 'POST',
				url: apiUrl.api_url_hubops + 'fmBagging/hubInScanFMBag',
				data: this.input,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			})
			.then(result => {
				if (result.data.ResultCode == 100) {

					this.isfmbagInScan = true;
					this.fmbagInScanObj = result.data.ResponseData;

					this.$alertify.success(result.data.ReturnMessage);
				}else if(result.data.ResultCode == 104){
					this.adherenceMsg = result.data.ReturnMessage;
					this.adherenceType = 'bag';
					this.bagConfirmData = result.data.ResponseData;
					this.showAdherenceModal = true;
				}else
				{
					this.$alertify.error(result.data.ReturnMessage);
				}
				this.isLoading = false;
			}, error => {
				this.isLoading = false;
				console.error(error);
			})
		},

		completeHubInScan() {
			if (!this.handoverBag) {
				this.handoverBagError = 'Bag Number field is required.'; return;
			}

			this.isLoading = true;

			this.input = ({
				"hubId": this.hubid[0],
				"userId": this.userid,
				"bagSealNumbers": this.handoverBag,
				"eventName": "CompleteHubInScan",
				"source": "WEB"
			})
			axios({
				method: 'POST',
				url: apiUrl.api_url_hubops + 'fmBagging/completeHubInScan',
				data: this.input,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			})
			.then(result => {
				if (result.data.ResultCode == 100) {
					this.$alertify.success(result.data.ReturnMessage);
				} else {
					this.$alertify.error(result.data.ReturnMessage);
				}
				this.isLoading = false;
			}, error => {
				this.isLoading = false;
				console.error(error);
			})
		},

	
		clearhandoverError(){
			if (this.handovertype) {
				this.handovererrors = '';
				this.handoverBag = '';
				this.fmbagInScanObj = {};

				this.isfmbagInScan = (this.handovertype == 'shipment') ? true : (this.handovertype == 'bag') ? false : this.isfmbagInScan;
			}
		},

		openFMShipmentPendencyList() {
			if (this.handovertype == '') {
				this.handovererrors = 'The Scan Type field is required.'; return;
			} else if (!this.handoverBag) {
				this.handoverBagError = 'Bag Number field is required.'; return;
			}

			this.handovererrors = '';
			this.handoverBagError = '';
			this.showfmlist = true;

			this.getFMBagPendencyInscan();
		},

		getFMBagPendencyInscan(){

			this.loadingFMList = true;
			this.fmPendencyList = [];

			this.input = ({
				"hubId": this.hubid[0],
				"bagSealNumber": this.handoverBag
			})
			axios({
				method: 'POST',
				url: apiUrl.api_url_hubops + 'fmBagging/getFMBagShipmentList',
				data: this.input,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			})
			.then(result => {
				if (result.data.ResultCode == 100) {
					let responseData = result.data.ResponseData;
					if (responseData && responseData.shipments) {
						responseData.pendingshipments = responseData.shipments;
					}
					this.fmPendencyList = responseData;
					this.showfmlist=true;
					this.$alertify.success(result.data.ReturnMessage)
				}else{
					this.$alertify.error(result.data.ReturnMessage)
				}
				this.loadingFMList=false;
			}, error => {
				console.error(error);
				this.loadingFMList=false;
			})
		},

		markFMShortage(data) {
			if(data) {
				this.$set(this.fmMarkingIds, data.shippingId, true);
			}

			this.loadingFMList = true;

			let payload = {
				hubId: this.hubid[0],
				shipmentIds: (this.pShipmentArr.length) ? this.pShipmentArr : [data.shippingId],
				bagId: this.handoverBag,
				userId: this.userid,
				createdBy: this.useremail,
				isSupervisor: this.supervisor,
				eventName: "RaiseShortageRequest"
			};

			axios.post(`${apiUrl.api_url_hubops}fmBagging/initiateORMarkFMShortage`, 
				payload, {
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
				}}
			).then(res => {
				if (res.data.ResultCode !== 100) this.$alertify.error(res.data.ReturnMessage || "Already Marked", "error");
				else {
					this.$alertify.success(res.data.ReturnMessage, "success");
					if(data) {
						data.isMarked = true;
					}
					this.getFMBagPendencyInscan();
					this.pShipmentArr = [];
				}

				this.loadingFMList = false;
				this.intiateFMShortage = false;
			}).catch(err => this.$alertify.error(err.message, "error"))
			.finally(() => {
				if(data) {
					this.$set(this.fmMarkingIds, data.shippingId, false);
				}
			});
		},

		closeFMModal() {
			this.intiateFMShortage = false;
			this.showfmlist = true;
		},

		resethandovertype(){
			this.handovertype = '',
			this.handovererrors = '',
			this.handoverBag = '',
			this.fmbagInScanObj = {};
			this.resetForm();
			
		},

		isfmMarked(shippingId) {
			let fmShip = this.fmPendencyList.pendingshipments.find(b => b.shippingId == shippingId);
			return fmShip && fmShip.isMarked;
		},

		updateCheckDest(event){
			this.checked[event.target.id] = event.target.checked;

			if(event.target.checked==false){
				this.pShipmentArr = this.pShipmentArr.filter(el => el != event.target.id)

			}else{
				this.pShipmentArr.indexOf(event.target.id) === -1 ? this.pShipmentArr.push(event.target.id):'';
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/components/HubInscan/Manual/Manual.js